enum ModalInputType {
  Email = 0,
  Text = 1,
  Digits = 2
}

export default Object.freeze(ModalInputType);
